var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExceptionReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 1.5C3.3335 0.947715 3.78121 0.5 4.3335 0.5H16.0002C16.2654 0.5 16.5197 0.605357 16.7073 0.792893L21.3739 5.45956C21.5615 5.6471 21.6668 5.90145 21.6668 6.16667V22.5C21.6668 23.0523 21.2191 23.5 20.6668 23.5H4.3335C3.78121 23.5 3.3335 23.0523 3.3335 22.5V1.5ZM5.3335 2.5V21.5H19.6668V7.16667H16.0002C15.4479 7.16667 15.0002 6.71895 15.0002 6.16667V2.5H5.3335Z",
    fill: "#76828F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 8C11.5001 7.44772 11.9478 7 12.5001 7C13.0524 7 13.5001 7.44772 13.5001 8V13C13.5001 13.5523 13.0524 14 12.5001 14C11.9478 14 11.5001 13.5523 11.5001 13V8Z",
    fill: "#76828F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 17C13.5001 17.5523 13.0524 18 12.5001 18C11.9478 18 11.5001 17.5523 11.5001 17C11.5001 16.4477 11.9478 16 12.5001 16C13.0524 16 13.5001 16.4477 13.5001 17Z",
    fill: "#76828F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExceptionReport);
export default __webpack_public_path__ + "static/media/exception-report.b83a218f9570d2b393b72df263315aaf.svg";
export { ForwardRef as ReactComponent };